import { Component } from '@angular/core'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { CurrentProductService } from '@spartacus/storefront'
import { MbProductTabSpecificationsConnector } from '../../../connectors'
import { MbDatasetEntryType } from '../../../../models'
import { isNotNullable } from '@spartacus/core'

@Component({
  selector: 'mb-pdp-specifications-tab',
  templateUrl: './pdp-specifications-tab.component.html',
  styleUrls: ['./pdp-specifications-tab.component.scss']
})
export class PdpSpecificationsTabComponent {

  productName: string | undefined
  mbDatasetEntryTypes = MbDatasetEntryType
  product$ = this.currentProductService.getProduct().pipe(
    filter(isNotNullable),
  )
  specifications$ = this.product$.pipe(
    tap(product => this.productName = product?.nameHtml),
    map(product => product.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.productSpecificationConnector.get(productCode)),
    filter(isNotNullable)
  )

  constructor (protected currentProductService: CurrentProductService,
              protected productSpecificationConnector: MbProductTabSpecificationsConnector) {
  }
}
